import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { SessionService } from '../../services/session/session.service';
import { UserService } from '../../services/user.service';
import {CommonModule} from "@angular/common";
import {TokenStorageService} from "../../services/storage/token-storage.service";

@Component({
    selector: 'app-trading-limits-institution',
    templateUrl: './trading-limits-institution.component.html',
    styleUrls: ['./trading-limits-institution.component.css'],
    standalone: false
})
export class TradingLimitsInstitutionComponent implements OnInit {
  tradeLimitSubmitted: boolean = false;
  masterTradeLimitSubmitted: boolean = false;
  tradeLimitForm: FormGroup = new FormGroup({});
  masterLimitForm: FormGroup = new FormGroup({});
  errorMessage: string = '';
  currencyList: any;
  loading: boolean = false;
  tradingLimitDone: boolean = false;
  masterTradingLimitDone: boolean = false;
  loadingMaster: boolean = false;
  isMasterLimit: boolean = false;
  env:any;
  constructor(
    private userService: UserService,
    private toastr: ToastrService,
    private formBuilder: FormBuilder,
    private session : SessionService,
    private tokenStorage: TokenStorageService
  ) { }

  ngOnInit(): void {
    this.getCurrencyList();
    this.initializeTradeLimitForm();
    this.initializeMasterTradeLimitForm();
    this.env = this.tokenStorage.getUserEnv();
  }
  getCurrencyList() {
    this.userService.getCurrencyList().subscribe({
      next: (data) => {
        if (data.status == 'SUCCESS') {
          this.currencyList = data.list.sort((a: any, b: any) =>
            a.type > b.type ? 1 : -1
          );
        } else {
          this.errorMessage = data.reason;
          this.toastr.error(
            this.errorMessage,
            'Error getting currency list'
          );
        }
      },
      error: (err) => {
        this.errorMessage = err.error.message;
        this.toastr.error(
          this.errorMessage,
          'Error getting currency list'
        );
      },
    });
  }

  initializeTradeLimitForm(): void {
    this.tradeLimitForm = this.formBuilder.group({
      currency: ['', [Validators.required]],
      odLimit: ['', [Validators.required]],
      marginLimit: ['', [Validators.required]],
      dayTradingLimit: ['', [Validators.required]],

    });
  }

  initializeMasterTradeLimitForm(): void {
    this.masterLimitForm = this.formBuilder.group({
      masterLimitCurrency: ['', [Validators.required]],
      masterLimit: ['', [Validators.required]],
    });
  }


  get formTradeLimitControl(): { [key: string]: AbstractControl } {
    return this.tradeLimitForm.controls;
  }

  get formMasterTradeLimitControl(): { [key: string]: AbstractControl } {
    return this.masterLimitForm.controls;
  }

  addTradeLimit() {
    this.tradeLimitSubmitted = true;
    if (this.tradeLimitForm.invalid) {
      return;
    }
    this.loading = true;
    const {
      currency,
      odLimit,
      marginLimit,
      dayTradingLimit,

    } = this.tradeLimitForm.value
    this.userService.addTradeLimit(this.session.getItem("newInstCode"),currency,odLimit,marginLimit,dayTradingLimit).subscribe({
      next: (data) => {
        if (data.status == 'SUCCESS') {
          this.toastr.success('Trade Limit added successfully', 'Success');
          this.tradingLimitDone = true;
          this.tradeLimitForm.get('currency')?.disable();
          this.tradeLimitForm.get('odLimit')?.disable();
          this.tradeLimitForm.get('marginLimit')?.disable();
          this.tradeLimitForm.get('dayTradingLimit')?.disable();
          this.tradeLimitSubmitted = false;
          this.loading = false;
          this.isMasterLimit = true;
        } else {
          this.errorMessage = data.reason;
          this.toastr.error(this.errorMessage, 'Error adding trade limit');
          this.loading = false;
        }
      },
      error: (err) => {
        this.errorMessage = err.error.message;
        this.toastr.error(this.errorMessage, 'Error adding trade limit');
        this.loading = false;
      },
    });
  }

  addMasterTradeLimit() {
    this.masterTradeLimitSubmitted = true;
    if (this.masterLimitForm.invalid) {
      return;
    }
    this.loadingMaster = true;
    const {
      masterLimitCurrency,
      masterLimit

    } = this.masterLimitForm.value
    this.userService.addMasterTradeLimit(this.session.getItem("newInstCode"),masterLimitCurrency,masterLimit).subscribe({
      next: (data) => {
        if (data.status == 'SUCCESS') {
          this.toastr.success('Master Trade Limit added successfully', 'Success');
          this.masterTradingLimitDone = true;
          this.masterLimitForm.get('masterLimitCurrency')?.disable();
          this.masterLimitForm.get('masterLimit')?.disable();
          this.masterTradeLimitSubmitted = false;
          this.loadingMaster = false;
        } else {
          this.errorMessage = data.reason;
          this.toastr.error(this.errorMessage, 'Error adding master trade limit');
          this.loadingMaster = false;
        }
      },
      error: (err) => {
        this.errorMessage = err.error.message;
        this.toastr.error(this.errorMessage, 'Error adding master trade limit');
        this.loadingMaster = false;
      },
    });
  }




}
